<ng-template #spinner>
   <mat-spinner diameter="30" class="common-mt05em"></mat-spinner>
</ng-template>

<ng-template #label>
   <ng-container *ngIf="account.active | async as active">
      <mat-icon *ngIf="active.primary" class="star">star</mat-icon>
      <span class="label">
         <span>{{active.name}}</span>
         <ng-container *ngIf="active.accountNumber">
            <ng-container *ngIf="!breakpoints.small">
               <span class="account-emptyspace">|</span>
               <span>ACCOUNT # {{active.accountNumber}}</span>
            </ng-container>
         </ng-container>
      </span>
   </ng-container>
</ng-template>

<ng-container *ngIf="!loading else spinner">
   <ng-container *ngIf="account.list | async as list else spinner">
      <ng-container *ngIf="list.length > 1 else single">
         <div id="locationSelector" class="account common-pointer" *ngIf="account.active | async as active" [matMenuTriggerFor]="accountMenu">
            <ng-container *ngTemplateOutlet="label"></ng-container>
            <mat-icon *ngIf="(account.list | async).length > 1">arrow_drop_down</mat-icon>

            <mat-menu #accountMenu="matMenu" xPosition="before" class="menu-account-select">
               <button class="account-button" mat-menu-item *ngFor="let item of list | slice : 0 : account.max" [disabled]="item.id === active.id" (click)="setActive( item.id )">
                  <mat-icon>{{item.id === active.id ? 'label_outline' : item.primary ? 'star' : '' }}</mat-icon>
                  <span class="account-namespace">{{item.name}}</span>
                  <ng-container *ngIf="item.accountNumber">
                     <ng-container *ngIf="!breakpoints.small">
                        <span class="account-emptyspace">|</span>
                        <span>ACCOUNT # {{item.accountNumber}}</span>
                     </ng-container>
                  </ng-container>
               </button>

               <button mat-menu-item routerLink="/user/account" *ngIf="list.length > account.max">
                  <mat-icon></mat-icon>More...
               </button>
            </mat-menu>
         </div>
      </ng-container>

      <ng-template #single>
         <div id="locationSelector" class="account">
            <ng-container *ngTemplateOutlet="label"></ng-container>
         </div>
      </ng-template>
   </ng-container>
</ng-container>
